/* eslint-disable */

import React from "react";
import { SearchBox, SearchBoxProps } from "searchkit";

class CustomSearchBox extends SearchBox {
  render() {
    if (!this.accessor) return null;
    let block = this.bemBlocks.container;

    return (
      <div className={block().state({ focused: this.state.focused })}>
        <form onSubmit={this.onSubmit.bind(this)}>
          <div className={block("icon")} style={{ marginTop: "5px", marginLeft: "2px" }}></div>
          <input
            type="text"
            data-qa="query"
            className={"form-control " + block("text")}
            style={{
              height: "initial",
              lineHeight: "initial",
              padding: "3px 10px",
              border: "1px solid #ccc",
              borderRadius: "3px",
            }}
            placeholder={this.props.placeholder || this.translate("searchbox.placeholder")}
            value={this.getValue()}
            onFocus={this.setFocusState.bind(this, true)}
            onBlur={this.setFocusState.bind(this, false)}
            ref="queryField"
            autoFocus={this.props.autofocus}
            onChange={this.onChange.bind(this)}
          />
          <input
            type="submit"
            value={this.translate("searchbox.button")}
            className={block("action")}
            data-qa="submit"
          />
          <div
            data-qa="loader"
            className={block("loader")
              .mix("sk-spinning-loader")
              .state({ hidden: !this.isLoading() })}
          ></div>
        </form>
      </div>
    );
  }
}
export default CustomSearchBox;
